import React from 'react';
import classNames from 'classnames';

import css from './Icons.module.css';

const IconMarketsAndEvents = props => {
  const { className } = props;
  const classes = classNames(className, css.smallIcon);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 512 512"
    >
      <g
        fill="none"
        stroke="#474747"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={15}
      >
        <path d="M121.02 91.886c0 24.936-20.214 45.15-45.15 45.15s-45.15-20.214-45.15-45.15l51-74.85h350l50.5 74.85c0 24.936-20.214 45.15-45.15 45.15s-45.15-20.214-45.15-45.15" />
        <path d="m141.485 18.036-20.466 73.85c0 24.936 20.214 45.15 45.15 45.15s45.15-20.214 45.15-45.15M301.62 91.886c0 24.936-20.214 45.15-45.15 45.15s-45.15-20.214-45.15-45.15l5-73.85" />
        <path d="m376.565 18.036 15.355 73.85c0 24.936-20.214 45.15-45.15 45.15s-45.15-20.214-45.15-45.15l-5-73.85M43.72 341.036h420v49.833h-420zM43.72 390.869h420v49.833h-420zM43.72 440.703h420v49.833h-420zM43.72 158.036v183M72.72 167.036v174M434.72 167.036v174M463.72 158.036v183M374.72 342.036v47M138.72 391.036v48M205.72 442.036v47" />
        <circle cx={140.72} cy={309.036} r={29} />
        <circle cx={198.72} cy={309.036} r={29} />
        <circle cx={256.72} cy={309.036} r={29} />
        <circle cx={314.72} cy={309.036} r={29} />
        <circle cx={169.72} cy={257.036} r={29} />
        <circle cx={227.72} cy={257.036} r={29} />
        <circle cx={285.72} cy={257.036} r={29} />
        <path d="M159.72 206.036s11 10 10 21M282.615 204.924s-6.603 13.319-1.666 23.2M358.119 206.787s-12.218 8.469-12.671 19.505" />
        <circle cx={372.72} cy={309.036} r={29} />
        <circle cx={343.72} cy={257.036} r={29} />
      </g>
    </svg>
  );
};

export default IconMarketsAndEvents;
